import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Layout from './layout/Layout';
import SignIn from './pages/SignIn';
import Dashboard from './pages/Dashboard';
import UserList from './pages/Users/UserList';
import UserForm from './pages/Users/UserForm';
import PlansList from './pages/Plans/PlansList';
import PlansForm from './pages/Plans/PlansForm';
import SubAdminList from './pages/Subadmin/SubAdminList';
import SubadminForm from './pages/Subadmin/SubAdminForm';
import PrivateRoute from './components/PrivateRoute';
import WithdrawalList from './pages/Withdrawals/WithdrawalList';
import WithdrawalDetails from './pages/Withdrawals/WithdrawalDetails';
import SupportTickets from './pages/Support/SupportTickets';
import SupportTicketDetails from './pages/Support/SupportTicketDetails';
import ReferralsList from './pages/Referrals/ReferralsList';
import ReferralDetails from './pages/Referrals/ReferralDetails';
import AdminWallets from './pages/adminWallets';
import TransactionListing from './pages/Transactions/TransactionListing';
import TransactionDetails from './pages/Transactions/TransactionDetails';
import UesrTransactions from './pages/Transactions/UserTransactions';
import UserWalletInfo from './pages/Users/UserWalletInfo';

const App = () => {
  return (
    <Router>
      <ToastContainer />
      <Routes>
          <Route path="/admin/signin" element={<SignIn />} />
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Layout />}>
              <Route path="/admin/dashboard" element={<Dashboard />} />
              <Route path="/admin/users" element={<UserList />} />
              <Route path="/admin/users/create" element={<UserForm />} />
              <Route path="/admin/users/edit/:id" element={<UserForm />} />
            
              <Route path="/admin/plans" element={<PlansList />} />
              <Route path="/admin/plans/create" element={<PlansForm />} />
              <Route path="/admin/plans/edit/:id" element={<PlansForm />} />

              <Route path="/admin/withdrawals" element={<WithdrawalList />} />
              <Route path="/admin/withdrawal/view/:id" element={<WithdrawalDetails />} />

              <Route path="/admin/support-tickets" element={<SupportTickets />} />
              <Route path="/admin/support-ticket/details/:id" element={<SupportTicketDetails />} />

              <Route path="/admin/referrals-list" element={<ReferralsList />} />
              <Route path="/admin/referral-details/:id" element={<ReferralDetails />} />
              
              <Route path="/admin/subadmins" element={<SubAdminList />} />
              <Route path="/admin/subadmins/create" element={<SubadminForm />} />
              <Route path="/admin/subadmins/edit/:id" element={<SubadminForm />} />

              <Route path="/admin/wallets" element={<AdminWallets />} />

              <Route path="/admin/transactions" element={<TransactionListing />} />
              <Route path="/admin/transaction/details/:transactionId" element={<TransactionDetails />} />
              <Route path="/admin/transactions/user/:userId" element={<UesrTransactions />} />

              <Route path="/admin/user/wallet/:userId" element={<UserWalletInfo />} />
            </Route>
          </Route>
        <Route path="*" element={<SignIn />} />
      </Routes>
    </Router>
  );
};

export default App;
